import { render, staticRenderFns } from "./MaintenanceRequest.vue?vue&type=template&id=9f4fe152&scoped=true&"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"
import style0 from "./MaintenanceRequest.vue?vue&type=style&index=0&id=9f4fe152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4fe152",
  null
  
)

export default component.exports